import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Table from "../../../../../core/pagination/datatable";

import PropTypes from "prop-types";

import { Select, Spin } from "antd";
import dayjs from "dayjs";
import { BASE_CRM_URL } from "../../../../components/config/config";
import axios from "axios";
import Swal from "sweetalert2";
import CommonFooter from "../../../../../core/common/footer/commonFooter";
import NewPayment from "../../Sales/Payments/NewPayment";

const ProjectInvoices = ({ projectId }) => {
  const [invoiceStatusOptions, setInvoiceStatusOptions] = useState([]);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [payDrawerOpen, setPayDrawerOpen] = useState(false);

  console.log(selectedInvoice, payDrawerOpen);

  const getInvoiceStatuses = async () => {
    try {
      const response = await fetch(`${BASE_CRM_URL}invoice/GetInvoiceStatus`);

      const data = await response.json();

      if (data.Status) {
        const options = data.ResultData.map((item) => ({
          value: item.Id,
          label: item.InvoiceStatus,
        }));

        setInvoiceStatusOptions(options);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const columns = [
    {
      title: "Invoice #",
      dataIndex: "invoice_no",

      render: (_, record) => {
        // const color =
        //   invoiceBadgeColors[record.status] || invoiceBadgeColors.Default;

        return (
          <Link
            to={`/crm/view/invoice`}
            state={{ record }}
            className="text-decoration-none"
          >
            <span
              className={``}
              // style={{
              //   fontSize: "13px",
              //   borderRadius: "8px",
              // }}
            >
              <i className="fa-regular fa-file-lines text-info me-2"></i>
              {record.prefix || ""}
              {record.number || ""}
            </span>
          </Link>
        );
      },
    },
    {
      title: "Customer",
      dataIndex: "ClientName",

      render: (_, record) => {
        // const clientName = record.ClientName || "Unknown Customer";

        // const initials = clientName
        //   .split(" ")
        //   .filter(Boolean)
        //   .slice(0, 2)
        //   .map((x) => x[0])
        //   .join("")
        //   .toUpperCase();

        // const avatarStyles = [
        //   { bg: "#E7F1FF", color: "#0D6EFD" },
        //   { bg: "#E8F8F0", color: "#198754" },
        //   { bg: "#FFF4E5", color: "#FD7E14" },
        //   { bg: "#F3E8FF", color: "#6F42C1" },
        //   { bg: "#E6FFFB", color: "#0D6EFD" },
        //   { bg: "#FCE7F3", color: "#D63384" },
        // ];

        // const style =
        //   avatarStyles[clientName.charCodeAt(0) % avatarStyles.length];

        return (
          <div className="d-flex align-items-start">
            {/* <Avatar
                  size={42}
                  style={{
                    background: style.bg,
                    color: style.color,
                    fontWeight: 700,
                    border: `1px solid ${style.color}20`,
                  }}
                >
                  {initials || "?"}
                </Avatar> */}

            <div className="ms-3">
              <div className="fw-semibold">
                {" "}
                <i className="fa-solid fa-building me-2 text-dark"></i>
                {record.ClientName || "N/A"}
              </div>

              <small className="text-muted">
                <i className="fa-solid fa-folder-open me-2"></i>
                {record.ProjectName || "N/A"}
              </small>
            </div>
          </div>
        );
      },
    },

    {
      title: "Amount",
      dataIndex: "total",

      render: (_, record) => (
        <>
          <div className="fw-semibold text-success">
            <i className="fa-solid fa-indian-rupee-sign me-2"></i>
            {record.total}
          </div>

          <small className="text-muted">
            <i className="fa-solid fa-percent me-2"></i>
            Tax : {record.total_tax}
          </small>
        </>
      ),
    },

    // {
    //   title: "Tags",
    //   dataIndex: "tags",

    //   render: (tags) => (
    //     <Tag
    //       color="blue"
    //       bordered={false}
    //       style={{
    //         borderRadius: 20,
    //         padding: "4px 12px",
    //         marginBottom: 5,
    //         fontWeight: 500,
    //       }}
    //       className="d-flex align-items-center"
    //     >
    //       <i className="fa-solid fa-tag me-2"></i>
    //       {tags?.map((tag) => (
    //         <div key={tag}>
    //           {tag}, {` `}
    //         </div>
    //       ))}
    //     </Tag>
    //   ),
    // },

    {
      title: "Invoice Date",
      dataIndex: "date",
      render: (date) => (
        <>
          <div>
            <i className="fa-regular fa-calendar me-2 text-primary"></i>
            {date ? dayjs(date).format("DD/MM/YYYY") : "-"}
          </div>
        </>
      ),
    },

    {
      title: "Due Date",
      dataIndex: "duedate",

      render: (duedate) => {
        if (!duedate) {
          return "-";
        }

        const due = dayjs(duedate);
        const today = dayjs().startOf("day");
        const days = due.startOf("day").diff(today, "day");

        return (
          <>
            <div>
              <i className="fa-regular fa-calendar-check me-2 text-primary"></i>
              {due.format("DD/MM/YYYY")}
            </div>

            <small
              className={
                days < 0
                  ? "text-danger"
                  : days <= 7
                    ? "text-warning"
                    : "text-success"
              }
            >
              <i className="fa-regular fa-clock me-2"></i>

              {days < 0
                ? `${Math.abs(days)} days overdue`
                : days === 0
                  ? "Due today"
                  : `${days} days left`}
            </small>
          </>
        );
      },
    },

    {
      title: "Status",
      dataIndex: "StatusName",

      render: (text, record) => {
        const getColor = (status) => {
          switch (status) {
            case "Draft":
              return "#0d6efd";

            case "Paid":
              return "#198754";

            case "Partially Paid":
              return "#ffc107";

            case "UnPaid":
              return "#dc3545";

            case "Cancelled":
              return "#dc3545";

            default:
              return "#6c757d";
          }
        };

        return (
          <Select
            value={
              invoiceStatusOptions.find(
                (item) => item.label === (text || "Draft"),
              )?.value
            }
            style={{ width: 120 }}
            options={invoiceStatusOptions}
            onChange={(value) => {
              updateInvoiceStatus(record.id, value);
            }}
            dropdownStyle={{ zIndex: 9999 }}
            optionRender={(option) => (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                }}
              >
                <i
                  className="fa-solid fa-circle"
                  style={{
                    color: getColor(option.data.label),
                    fontSize: 10,
                  }}
                ></i>

                {option.data.label}
              </div>
            )}
            labelRender={({ value }) => {
              const status = invoiceStatusOptions.find(
                (x) => x.value === value,
              );

              return (
                <span>
                  <i
                    className="fa-solid fa-circle me-2"
                    style={{
                      color: getColor(status?.label),
                      fontSize: 10,
                    }}
                  ></i>
                  {status?.label}
                </span>
              );
            }}
          />
        );
      },
    },

    {
      title: "Action",
      dataIndex: "action",

      render: (_, record) => (
        <>
          {/* <Link className="action-set" to="#" data-bs-toggle="dropdown">
                <i className="fa fa-ellipsis-v btn border"></i>
              </Link>
    
              <ul className="dropdown-menu">
                <li>
                  <Link
                    className="dropdown-item"
                    to={`/crm/view/invoice`}
                    state={{ record }}
                  >
                    <Eye className="me-2 text-info" />
                    View
                  </Link>
                </li>
    
                <li>
                  <Link
                    to={`/crm/update/invoice/${record.id}`}
                    className="dropdown-item"
                  >
                    <Edit className="me-2 text-primary" />
                    Edit
                  </Link>
                </li>
                <li>
                  {record?.StatusName !== "Paid" &&
                    record?.StatusName !== "Cancelled" && (
                      <Link
                        to="#"
                        className="dropdown-item"
                        onClick={(e) => {
                          e.preventDefault();
                          setSelectedInvoice(record);
                          setPayDrawerOpen(true);
                        }}
                      >
                        <CreditCard className="me-2 text-success" />
                        Payment
                      </Link>
                    )}
                </li>
      
              </ul> */}
          <div className="action-table-data">
            <div className="edit-delete-action ">
              <Link
                title="Edit"
                to={`/crm/update/invoice/${record.id}`}
                className="text-primary me-2 p-2"
              >
                <i className="ti ti-pencil text-primary"></i>
              </Link>

              {record?.StatusName !== "Paid" &&
                record?.StatusName !== "Cancelled" && (
                  <Link
                    title="Payment"
                    to="#"
                    className="me-2 p-2"
                    onClick={(e) => {
                      e.preventDefault();
                      setSelectedInvoice(record);
                      setPayDrawerOpen(true);
                    }}
                  >
                    <i className="ti ti-credit-card text-success"></i>
                  </Link>
                )}
            </div>
          </div>
        </>
      ),
    },
  ];

  const [invoice, setInvoice] = useState([]);
  const [invoiceLoading, setInvoiceLoading] = useState(false);

  const [selectedStatus, setSelectedStatus] = useState(0);

  const fetchInvoice = async (status = 0) => {
    try {
      setInvoiceLoading(true);

      const response = await axios.get(
        `${BASE_CRM_URL}invoice/GetInvoiceByProjId?&ProjId=${projectId}`,
        {
          params: {
            Status: status,
          },
        },
      );

      if (response.data?.Status) {
        setInvoice(response.data.ResultData || []);
      } else {
        setInvoice([]);
      }
    } catch (error) {
      console.error("Get Estimates Error:", error);
      setInvoice([]);
    } finally {
      setInvoiceLoading(false);
    }
  };

  const updateInvoiceStatus = async (InvoiceId, statusId) => {
    try {
      const response = await fetch(
        `${BASE_CRM_URL}invoice/UpdateInvoiceStatus`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: InvoiceId,
            status: statusId,
          }),
        },
      );

      const data = await response.json();

      if (data.Status) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: data.Message,
          timer: 1200,
          showConfirmButton: false,
        });

        fetchInvoice(0); // Reload your proposal list
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed",
          text: data.Message,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchInvoice(0);
    getInvoiceStatuses();
  }, []);

  return (
    <div className="page-wrapper py-0">
      <div className="content py-0">
        <div className="page-header py-0">
          <div className="add-item d-flex">
            <div className="page-title">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                
                  <h4 className="breadcrumb-item " aria-current="page">
                    Project Invoices
                  </h4>
                </ol>
              </nav>
           
            </div>
          </div>
        </div>

        {/* /product list */}
        <div className="card table-list-card ">
          <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
            <div className="search-set"></div>
            <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
              <div className="dropdown me-2">
                <Select
                  placeholder="Status"
                  style={{ width: 150 }}
                  value={selectedStatus}
                  onChange={(value) => {
                    setSelectedStatus(value);
                    fetchInvoice(value);
                  }}
                  options={[
                    {
                      value: 0,
                      label: "All",
                    },
                    ...invoiceStatusOptions,
                  ]}
                />
              </div>
            </div>
          </div>

          <div className="card-body">
            <div className=" table-responsive">
              {invoiceLoading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "250px", // adjust height if needed
                  }}
                >
                  <Spin size="large" />
                </div>
              ) : (
                <Table columns={columns} dataSource={invoice} />
              )}
            </div>
          </div>
        </div>
        {/* /product list */}
      </div>
      <NewPayment
        open={payDrawerOpen}
        setOpen={setPayDrawerOpen}
        record={selectedInvoice}
      />
      <CommonFooter />
    </div>
  );
};
ProjectInvoices.propTypes = {
  projectId: PropTypes.number,
};
export default ProjectInvoices;
